import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscribeComponent } from 'src/app/components/all-modals/subscribe/subscribe.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UnsubscribeComponent } from 'src/app/components/all-modals/unsubscribe/unsubscribe.component';
import { ConnectionConfirmationModalComponent } from 'src/app/components/profile/connection-confirmation-modal/connection-confirmation-modal.component';
import { SuccessMessageComponent } from 'src/app/components/all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
import { ProfileService } from 'src/app/core/services/profile.service';
import { PaymentDeclinedComponent } from 'src/app/components/all-modals/payment-declined/payment-declined.component';
import { WalletService } from 'src/app/core/services/wallet.service';
import { TokensAddedComponent } from 'src/app/components/wallet/tokens-added/tokens-added.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-subscription-user',
  templateUrl: './subscription-user.component.html',
  styleUrls: ['./subscription-user.component.scss']
})
export class SubscriptionUserComponent implements OnInit, OnDestroy {

  @Input() public activeTab;
  @Input() public users;
  @Input() public type;
  @Input() public totalUser;
  @Input() public loggedUser;
  @Input() public p;
  @Output() paginateSeach = new EventEmitter();
  @Output() changeTab = new EventEmitter();

  totalCount = 0;
  recordsPerPage = 15;
  imgURL = API_ENDPOINTS.BASE_URL;
  activeSubscription: Subscription;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private _profileService: ProfileService,
    private _walletService: WalletService
  ) { }

  ngOnInit() {
    this.activeSubscription = this.activatedRoute.queryParams.subscribe(params => {
      const user_id = params ? params.user_id : '';
      if (this.users.length && user_id) {
        const user = this.users.find(u => u.id == +user_id);
        if (params && params.source == 'subscriptionModal' && !params.status && user) {
          if (params.amount) {
            this.checkRecentTransaction(params.amount, user);
          } else {
            this.subscribe(user);
          }
          this.router.navigate([], {
            queryParams: {
              'source': null,
              'amount': null,
              'user_id': null
            },
            queryParamsHandling: 'merge'
          });
        } else if (params && params.source == 'subscriptionModal' && params.status == 'false' && user) {
          this.subscribe(user);
          this.router.navigate([], {
            queryParams: {
              'source': null,
              'amount': null,
              'user_id': null,
              'status': null
            },
            queryParamsHandling: 'merge'
          });
        }
      }
    });
  }

  paginateTransactions(event) {
    this.p = event;
    this.paginateSeach.emit(this.p);
  }

  toggleView(view) {
    this.changeTab.emit(view);
  }

  onClickUser(id) {
    this.router.navigate(['/other-profile', id])
  }

  subscribe(data) {
    // check for if business pro plus plan
    let options = { centered: true, windowClass: "subscribe-modal", keyboard: false }
    // if ((data.library_price || data.library_price === 0) && !data.verification_rejected) {
      options['size'] = 'lg';
    // }

    options['backdrop'] = 'static';
    options['keyboard'] = false;
    let upgrade;
    if (data.subscriber_request_details && data.subscriber_request_details.sender && data.subscriber_request_details.sender.status == 'subscribed') {
      upgrade = true;
      options['size'] = 'md';
    }
    const modalRef = this.modalService.open(SubscribeComponent, options);
    modalRef.componentInstance.currentuser = data;
    modalRef.componentInstance.upgrade = upgrade;
    modalRef.result.then((result) => {
      if (result) {
        if (result.id) {
          data.subscriber_request_details.sender.subscriber_id = result.id;
        }
        (result.status == 'pending') ? data.subscriber_request_details.sender.status = 'pending' : data.subscriber_request_details.sender.status = 'subscribed';
        data.subscriber_request_details.sender.auto_renew = result.auto_renew;
        data.subscriber_request_details.sender.expired_at = result.expired_at;
        if (result.paid_subscriber) {
          data.subscriber_request_details.sender.paid_subscriber = result.paid_subscriber;
        }
      }
    });
    return;
  }
  unsubscribe(data) {
    const modalRef = this.modalService.open(UnsubscribeComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.currentuser = data;
    modalRef.result.then((result) => {
      if (result == 'success') {
        if (!data.subscriber_request_details.sender.paid_subscriber) {
          data.subscriber_request_details.sender.status = '';
          data.subscriber_request_details.sender.subscriber_id = 0;
        } else {
          data.subscriber_request_details.sender.auto_renew = !data.subscriber_request_details.sender.auto_renew;
        }
      } else if (result == 'upgrade') {
        const modalRef = this.modalService.open(SubscribeComponent, { centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.currentuser = data;
        modalRef.componentInstance.upgrade = true;
        modalRef.result.then((result) => {
          if (result) {
            if (result.id) {
              data.subscriber_request_details.sender.subscriber_id = result.id;
            }
            (result.status == 'pending') ? data.subscriber_request_details.sender.status = 'pending' : data.subscriber_request_details.sender.status = 'subscribed';
            data.subscriber_request_details.sender.auto_renew = result.auto_renew;
            data.subscriber_request_details.sender.expired_at = result.expired_at;
            if (result.paid_subscriber) {
              data.subscriber_request_details.sender.paid_subscriber = result.paid_subscriber;
            }
          }
        });
      }
    });
    return;
  }


  checkRecentTransaction(amount, user) {
    this._walletService.recentTransactionDetails().subscribe((response) => {
      if (response.success) {
        if (response.data.recent_payment_status == 'success') {
          this.openTokenAdded(amount, user);
        } else if (response.data.recent_payment_status == 'pending') {
          const modalRef = this.modalService.open(PaymentDeclinedComponent, { size: "lg", centered: true });
          modalRef.componentInstance.title = "Transaction Pending!";
          modalRef.componentInstance.message = "Sorry, Your transaction has been pending due to some technical issues. We are updating your transaction within 5-10 minutes. Please check your transaction status in the wallet section.";
        } else if (response.data.recent_payment_status == 'failure') {
          const modalRef = this.modalService.open(PaymentDeclinedComponent, { size: "lg", centered: true });
          modalRef.componentInstance.title = "Payment Failure!";
          modalRef.componentInstance.message = "Sorry, We are unable to process your payment at this time. Please try again later.";
        } else {
          this.openTokenAdded(amount, user);
        }
      } else {
        this.openTokenAdded(amount, user);
      }
    }, (error) => {
      this.openTokenAdded(amount, user);
    })
  }

  openTokenAdded(amount, user) {
    const modalRef = this.modalService.open(TokensAddedComponent, { centered: true });
    modalRef.componentInstance.amount = amount;
    modalRef.result.then((response) => {
      this.subscribe(user);
    }, (error) => {
      this.subscribe(user);
    })
  }

  cancelSubscribe(user) {
    const modalRef = this.modalService.open(ConnectionConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.userData = { user: user };
    modalRef.componentInstance.return = true;
    modalRef.componentInstance.title = "Cancel Subscribing Request";
    modalRef.componentInstance.message = "Are you sure you want to cancel Subscribing request?";
    modalRef.componentInstance.successBtn = "Yes";
    modalRef.result.then((result) => {
      if (result == 'success') {
        this._profileService.profileUnsubscribe('unsubscribed', user.subscriber_request_details.sender.subscriber_id).subscribe((response) => {
          if (response.success) {
            const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modalRef.componentInstance.message = "You have successfully canceled your subscribing request to " + ((user.business_profile && user.business_profile[0].name) ? user.business_profile[0].name : user.name);
            user.subscriber_request_details.sender.status = '';
            user.subscriber_request_details.sender.subscriber_id = 0;
          }
          else if (!response.success) {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = "Error occured canceling subscribing request to " + ((user.business_profile && user.business_profile[0].name) ? user.business_profile[0].name : user.name) + ".";
          }
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.activeSubscription) {
      this.activeSubscription.unsubscribe();
    }
  }
}
